import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, Clock } from 'lucide-react'
import { AuthSplitLayout } from '@/components/layout/AuthSplitLayout'

const SUPPORT_EMAIL = 'support@agion.ai'

/** A waitlisted account signed in before its organization was activated. */
export const WaitlistPendingPage = () => {
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="lp-state lp-pop">
        <div className="lp-badge lp-badge-brand">
          <Clock size={24} aria-hidden="true" />
        </div>
        <h2 className="lp-state-title">{t('waitlist.pendingTitle')}</h2>
        <p className="lp-state-msg">{t('waitlist.pendingMessage')}</p>
        <p className="lp-support">
          {t('waitlist.pendingContact')}{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </p>
        <Link to="/login" className="lp-back">
          <ArrowLeft size={16} aria-hidden="true" />
          {t('waitlist.backToSignIn')}
        </Link>
      </div>
    </AuthSplitLayout>
  )
}
